module.exports = __webpack_public_path__ + "static/media/bgd1Empty@2x.65a9656c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/bgd1Empty@2x.png
// module id = 1148
// module chunks = 0